"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partToMF = partToMF;
const Kind_1 = require("../Kind");
function partToMF(part, options = {}) {
    let mf = [];
    for (let line of part) {
        switch (line.kind) {
            case Kind_1.Kind.ISOTOPE:
                if (line.multiplier !== 0) {
                    mf.push(`[${line.value.isotope}${line.value.atom}]${line.multiplier !== 1 ? line.multiplier : ''}`);
                }
                break;
            case Kind_1.Kind.ISOTOPE_RATIO:
                if (line.multiplier !== 0) {
                    mf.push(`${line.value.atom}{${line.value.ratio.join(',')}}${line.multiplier !== 1 ? line.multiplier : ''}`);
                }
                break;
            case Kind_1.Kind.ATOM:
                if (line.multiplier !== 0) {
                    mf.push(line.value + (line.multiplier !== 1 ? line.multiplier : ''));
                }
                break;
            case Kind_1.Kind.CHARGE:
                if (line.value === 0 || options.neutral)
                    break;
                mf.push(`(${line.value > 0 ? `+${line.value}` : line.value})`);
                break;
            default:
        }
    }
    return mf.join('');
}
//# sourceMappingURL=partToMF.js.map